/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "joysticks";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Rates {
  ascendSpeed: number;
  descendSpeed: number;
  forwardSpeed: number;
  lateralSpeed: number;
  headingRate: number;
  gimbalPitchRate: number;
}

function createBaseRates(): Rates {
  return { ascendSpeed: 0, descendSpeed: 0, forwardSpeed: 0, lateralSpeed: 0, headingRate: 0, gimbalPitchRate: 0 };
}

export const Rates = {
  encode(message: Rates, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ascendSpeed !== 0) {
      writer.uint32(13).float(message.ascendSpeed);
    }
    if (message.descendSpeed !== 0) {
      writer.uint32(21).float(message.descendSpeed);
    }
    if (message.forwardSpeed !== 0) {
      writer.uint32(29).float(message.forwardSpeed);
    }
    if (message.lateralSpeed !== 0) {
      writer.uint32(37).float(message.lateralSpeed);
    }
    if (message.headingRate !== 0) {
      writer.uint32(45).float(message.headingRate);
    }
    if (message.gimbalPitchRate !== 0) {
      writer.uint32(53).float(message.gimbalPitchRate);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Rates {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRates();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.ascendSpeed = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.descendSpeed = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.forwardSpeed = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.lateralSpeed = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.headingRate = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.gimbalPitchRate = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Rates {
    return {
      ascendSpeed: isSet(object.ascendSpeed) ? globalThis.Number(object.ascendSpeed) : 0,
      descendSpeed: isSet(object.descendSpeed) ? globalThis.Number(object.descendSpeed) : 0,
      forwardSpeed: isSet(object.forwardSpeed) ? globalThis.Number(object.forwardSpeed) : 0,
      lateralSpeed: isSet(object.lateralSpeed) ? globalThis.Number(object.lateralSpeed) : 0,
      headingRate: isSet(object.headingRate) ? globalThis.Number(object.headingRate) : 0,
      gimbalPitchRate: isSet(object.gimbalPitchRate) ? globalThis.Number(object.gimbalPitchRate) : 0,
    };
  },

  toJSON(message: Rates): unknown {
    const obj: any = {};
    if (message.ascendSpeed !== 0) {
      obj.ascendSpeed = message.ascendSpeed;
    }
    if (message.descendSpeed !== 0) {
      obj.descendSpeed = message.descendSpeed;
    }
    if (message.forwardSpeed !== 0) {
      obj.forwardSpeed = message.forwardSpeed;
    }
    if (message.lateralSpeed !== 0) {
      obj.lateralSpeed = message.lateralSpeed;
    }
    if (message.headingRate !== 0) {
      obj.headingRate = message.headingRate;
    }
    if (message.gimbalPitchRate !== 0) {
      obj.gimbalPitchRate = message.gimbalPitchRate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Rates>, I>>(base?: I): Rates {
    return Rates.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Rates>, I>>(object: I): Rates {
    const message = createBaseRates();
    message.ascendSpeed = object.ascendSpeed ?? 0;
    message.descendSpeed = object.descendSpeed ?? 0;
    message.forwardSpeed = object.forwardSpeed ?? 0;
    message.lateralSpeed = object.lateralSpeed ?? 0;
    message.headingRate = object.headingRate ?? 0;
    message.gimbalPitchRate = object.gimbalPitchRate ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
